import React, { createContext, useContext, useState } from "react";

const ScrollContext = createContext<{
  isScrolled: boolean;
  isMenuClosed: boolean;
  setIsScrolled: React.Dispatch<React.SetStateAction<boolean>>;
  setIsMenuClosed: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isScrolled: false,
  isMenuClosed: true,
  setIsScrolled: () => {},
  setIsMenuClosed: () => {},
});

export const ScrollProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuClosed, setIsMenuClosed] = useState(true);

  return (
    <ScrollContext.Provider
      value={{ isScrolled, setIsScrolled, isMenuClosed, setIsMenuClosed }}
    >
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = () => useContext(ScrollContext);
